export const rsDigitList=[
    "0","1","2","3","4","5","6","7","8","9",
    "10","11"
]
export const rsDegList=[
    "0","1","2","3","4","5","6","7","8","9",
    "10","11","12","13","14","15","16","17","18","19",
    "20","21","22","23","24","25","26","27","28","29"
]
export const minList=[
    "0","1","2","3","4","5","6","7","8","9",
    "10","11","12","13","14","15","16","17","18","19",
    "20","21","22","23","24","25","26","27","28","29",
    "30","31","32","33","34","35","36","37","38","39",
    "40","41","42","43","44","45","46","47","48","49",
    "50","51","52","53","54","55","56","57","58","59",
]
export const mnMthList=[
    "1","2","3","4","5","6","7","8","9",
    "10","11","12"
]
export const dithyMnList=[
    "0","1","2","3","4","5","6","7","8","9",
    "10","11","12","13","14"
]
export const ausMnList=[
    "1","2","3","4","5","6","7","8","9","10",
    "11","12","13","14","15","16","17","18","19","20",
    "21","22","23","24","25","26","27",
]

export const upRamAtList=
["1", "2","3", "4", "5", "6", "7", "8" , "9", "10", "11", "12", "13", "14", "15"]

export const up = {
    day : 1,
    week : 5,
    halfMonth : 10,
    month : 20
} // บาท
export const day=[
    "01","02","03","04","05","06","07","08","09","10",
    "11","12","13","14","15","16","17","18","19","20",
    "21","22","23","24","25","26","27","28","29","30","31"
]
export const month=[
    "มกราคม/01","กุมภาพันธ์/02","มีนาคม/03","เมษายน/04","พฤษภาคม/05","มิถุนายน/06",
    "กรกฎาคม/07","สิงหาคม/08","กันยายน/09","ตุลาคม/10","พฤศจิกายน/11","ธันวาคม/12"
]
export const wkwk=[
    {ww: "16/2568", startDate: "2025,04,13"},
    {ww: "17/2568", startDate: "2025,04,20"},
    {ww: "18/2568", startDate: "2025,04,27"},
    {ww: "19/2568", startDate: "2025,05,04"},
    {ww: "20/2568", startDate: "2025,05,11"},
    {ww: "21/2568", startDate: "2025,05,18"},
    {ww: "22/2568", startDate: "2025,05,25"},
    {ww: "23/2568", startDate: "2025,06,01"},
    {ww: "24/2568", startDate: "2025,06,08"},
    {ww: "25/2568", startDate: "2025,06,15"},
    {ww: "26/2568", startDate: "2025,06,22"},
    {ww: "27/2568", startDate: "2025,07,29"},
    {ww: "28/2568", startDate: "2025,07,06"},
    {ww: "29/2568", startDate: "2025,07,13"},
    {ww: "30/2568", startDate: "2025,07,20"},
    {ww: "31/2568", startDate: "2025,07,27"},
    {ww: "32/2568", startDate: "2025,08,03"},
    {ww: "33/2568", startDate: "2025,08,10"},
    {ww: "34/2568", startDate: "2025,08,17"},
    {ww: "35/2568", startDate: "2025,08,24"},
    {ww: "36/2568", startDate: "2025,08,31"},
    {ww: "37/2568", startDate: "2025,09,07"},
    {ww: "38/2568", startDate: "2025,09,14"},
    {ww: "39/2568", startDate: "2025,09,21"},
    {ww: "40/2568", startDate: "2025,09,28"},
    {ww: "41/2568", startDate: "2025,10,05"},
    {ww: "42/2568", startDate: "2025,10,12"},
    {ww: "43/2568", startDate: "2025,10,19"},
    {ww: "44/2568", startDate: "2025,10,26"},
    {ww: "45/2568", startDate: "2025,11,02"},
    {ww: "46/2568", startDate: "2025,11,09"},
    {ww: "47/2568", startDate: "2025,11,16"},
    {ww: "48/2568", startDate: "2025,11,23"},
    {ww: "49/2568", startDate: "2025,11,30"},
    {ww: "50/2568", startDate: "2025,12,07"},
    {ww: "51/2568", startDate: "2025,12,14"},
    {ww: "52/2568", startDate: "2025,12,21"},
    {ww: "01/2569", startDate: "2025,12,28"},
    {ww: "02/2569", startDate: "2026,01,04"},
    {ww: "03/2569", startDate: "2026,01,11"},
    {ww: "04/2569", startDate: "2026,01,18"},
    {ww: "05/2569", startDate: "2026,01,25"},
    {ww: "06/2569", startDate: "2026,02,01"},
    {ww: "07/2569", startDate: "2026,02,08"},
    {ww: "08/2569", startDate: "2026,02,15"},
    {ww: "09/2569", startDate: "2026,02,22"},
    {ww: "10/2569", startDate: "2026,03,01"},
    {ww: "11/2569", startDate: "2026,03,08"},
    {ww: "12/2569", startDate: "2026,03,15"},
    {ww: "13/2569", startDate: "2026,03,22"},
    {ww: "14/2569", startDate: "2026,03,29"},
    {ww: "15/2569", startDate: "2026,04,05"},
    {ww: "16/2569", startDate: "2026,04,12"},
    {ww: "17/2569", startDate: "2026,04,19"},
    {ww: "18/2569", startDate: "2026,04,26"},
    {ww: "19/2569", startDate: "2026,05,03"},
    {ww: "20/2569", startDate: "2026,05,10"},
    {ww: "21/2569", startDate: "2026,05,17"},
    {ww: "22/2569", startDate: "2026,05,24"},
    {ww: "23/2569", startDate: "2026,05,31"},
    {ww: "24/2569", startDate: "2026,06,07"},
    {ww: "25/2569", startDate: "2026,06,14"},
    {ww: "26/2569", startDate: "2026,06,21"},
    {ww: "27/2569", startDate: "2026,06,28"},
    {ww: "28/2569", startDate: "2026,07,05"},
    {ww: "29/2569", startDate: "2026,07,12"},
    {ww: "30/2569", startDate: "2026,07,16"},
    {ww: "31/2569", startDate: "2026,07,26"},
    {ww: "32/2569", startDate: "2026,08,02"},
    {ww: "33/2569", startDate: "2026,08,09"},
    {ww: "34/2569", startDate: "2026,08,16"},
    {ww: "35/2569", startDate: "2026,08,23"},
    {ww: "36/2569", startDate: "2026,08,30"},
    {ww: "37/2569", startDate: "2026,09,06"},
    {ww: "38/2569", startDate: "2026,09,13"},
    {ww: "39/2569", startDate: "2026,09,20"},
    {ww: "40/2569", startDate: "2026,09,27"},
    {ww: "41/2569", startDate: "2026,10,04"},
    {ww: "42/2569", startDate: "2026,10,11"},
    {ww: "43/2569", startDate: "2026,10,18"},
    {ww: "44/2569", startDate: "2026,10,25"},
    {ww: "45/2569", startDate: "2026,11,01"},
    {ww: "46/2569", startDate: "2026,11,08"},
    {ww: "47/2569", startDate: "2026,11,15"},
    {ww: "48/2569", startDate: "2026,11,22"},
    {ww: "49/2569", startDate: "2026,11,29"},
    {ww: "50/2569", startDate: "2026,12,06"},
    {ww: "51/2569", startDate: "2026,12,13"},
    {ww: "52/2569", startDate: "2026,12,20"},
    {ww: "53/2569", startDate: "2026,12,27"},
    {ww: "01/2570", startDate: "2027,01,03"},
]
export const year=[
    // "2480 /1937","2481 /1938","2482 /1939","2483 /1940","2484 /1941","2485 /1942","2486 /1943","2487 /1944","2488 /1945","2489 /1946",
    // "2490 /1947","2491 /1948","2492 /1949","2493 /1950",
    "2494 /1951","2495 /1952","2496 /1953","2497 /1954","2498 /1955","2499 /1956",
    "2500 /1957","2501 /1958","2502 /1959","2503 /1960","2504 /1961","2505 /1962","2506 /1963","2507 /1964","2508 /1965","2509 /1966",
    "2510 /1967","2511 /1968","2512 /1969","2513 /1970","2514 /1971","2515 /1972","2516 /1973","2517 /1974","2518 /1975","2519 /1976",
    "2520 /1977","2521 /1978","2522 /1979","2523 /1980","2524 /1981","2525 /1982","2526 /1983","2527 /1984","2528 /1985","2529 /1986",
    "2530 /1987","2531 /1988","2532 /1989","2533 /1990","2534 /1991","2535 /1992","2536 /1993","2537 /1994","2538 /1995","2539 /1996",
    "2540 /1997","2541 /1998","2542 /1999","2543 /2000","2544 /2001","2545 /2002","2546 /2003","2547 /2004","2548 /2005","2549 /2006",
    "2550 /2007","2551 /2008","2552 /2009","2553 /2010","2554 /2011","2555 /2012","2556 /2013","2557 /2014","2558 /2015","2559 /2016",
    "2560 /2017","2561 /2018","2562 /2019","2563 /2020","2564 /2021","2565 /2022","2566 /2023","2567 /2024","2568 /2025","2569 /2026",
    "2570 /2027","2571 /2028","2572 /2029","2573 /2030",
    // "2574 /2031","2575 /2032","2576 /2033","2577 /2034","2578 /2035","2579 /2036",
    // "2580 /2037","2581 /2038","2582 /2039","2583 /2040","2574 /2031","2575 /2032","2576 /2033","2577 /2034","2578 /2035","2579 /2036",
]
export const sunRise=[
    {month:"01" , day : "01" , srHr : 6, srMin : 29},
    {month:"01" , day : "10" , srHr : 6, srMin : 32},
    {month:"01" , day : "20" , srHr : 6, srMin : 33},
    {month:"02" , day : "01" , srHr : 6, srMin : 33},
    {month:"02" , day : "10" , srHr : 6, srMin : 30},
    {month:"02" , day : "20" , srHr : 6, srMin : 26},
    {month:"03" , day : "01" , srHr : 6, srMin : 21},
    {month:"03" , day : "10" , srHr : 6, srMin : 14},
    {month:"03" , day : "20" , srHr : 6, srMin : 8},
    {month:"04" , day : "01" , srHr : 6, srMin : 0},
    {month:"04" , day : "10" , srHr : 5, srMin : 53},
    {month:"04" , day : "20" , srHr : 5, srMin : 47},
    {month:"05" , day : "01" , srHr : 5, srMin : 41},
    {month:"05" , day : "10" , srHr : 5, srMin : 36},
    {month:"05" , day : "20" , srHr : 5, srMin : 34},
    {month:"06" , day : "01" , srHr : 5, srMin : 33},
    {month:"06" , day : "10" , srHr : 5, srMin : 33},
    {month:"06" , day : "20" , srHr : 5, srMin : 34},
    {month:"07" , day : "01" , srHr : 5, srMin : 38},
    {month:"07" , day : "10" , srHr : 5, srMin : 40},
    {month:"07" , day : "20" , srHr : 5, srMin : 43},
    {month:"08" , day : "01" , srHr : 5, srMin : 46},
    {month:"08" , day : "10" , srHr : 5, srMin : 48},
    {month:"08" , day : "20" , srHr : 5, srMin : 50},
    {month:"09" , day : "01" , srHr : 5, srMin : 51},
    {month:"09" , day : "10" , srHr : 5, srMin : 52},
    {month:"09" , day : "20" , srHr : 5, srMin : 53},
    {month:"10" , day : "01" , srHr : 5, srMin : 53},
    {month:"10" , day : "10" , srHr : 5, srMin : 54},
    {month:"10" , day : "20" , srHr : 5, srMin : 56},
    {month:"11" , day : "01" , srHr : 5, srMin : 59},
    {month:"11" , day : "10" , srHr : 6, srMin : 3},
    {month:"11" , day : "20" , srHr : 6, srMin : 8},
    {month:"12" , day : "01" , srHr : 6, srMin : 14},
    {month:"12" , day : "10" , srHr : 6, srMin : 19},
    {month:"12" , day : "20" , srHr : 6, srMin : 24},
    {month:"13" , day : "01" , srHr : 6, srMin : 29},
]
